module.exports = __webpack_public_path__ + "static/media/ranger4wd2009.6ab9367d.jpg";